import styled from 'styled-components'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Title = styled.h1`
  margin: 8rem 0 0;
  font: 600 5rem ${theme.fonts.headings};
  text-transform: uppercase;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0.001;
  position: absolute;
`

export const Header = styled.div`
  padding: 3rem 0;

  ${mq.medium} {
    padding: 5rem 0;
  }

  &::after {
    content: '';
    display: block;
    clear: both;
  }
`

export const Subtitle = styled(Title).attrs({ as: 'h2' })`
  margin: 6rem 0 3rem;
  font-size: 3.5rem;
  clear: both;
`

export const Img = styled.img`
  display: none;
  float: right;
  max-width: 100%;
  margin-left: 3rem;

  ${mq.medium} {
    display: block;
  }
`

export const Links = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  gap: 2rem;
`

export const Link = styled.a`
  display: block;
  padding: 0.4em 0.4em 0.3em;
  color: white;
  text-decoration: none;
  text-align: center;
  background: #7d161d;

  svg {
    margin: -0.15em 0 -0.32em -0.3em;
    font-size: 2em;
  }

  &:hover,
  &:focus {
    color: white;
    opacity: 0.8;
  }
`
